import mask from './mask'

export default {
  install: app => {
    app.directive('mask', mask)
  }
}
